import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import {
  postGoogleSync,
  postGoogleLink,
  postGoogleDisassociation,
} from '../../apis/setting'
import { setErrors } from '../common/errorsSlice'
import {
  GoogleSyncResponse,
  GoogleCallbackUrl,
} from '../../types/setting'

export interface GoogleSyncState extends GoogleSyncResponse {
  isSucceeded: boolean | null
}

const initialState: GoogleSyncState = {
  login_url: "",
  isSucceeded: null,
}

const googleSyncSlice = createSlice({
  name: 'googleSync',
  initialState,
  reducers: {
    requestStart: (state) => state,
    postGoogleSyncSuccess: (state, action: PayloadAction<GoogleSyncResponse>) => {
      state.login_url = action.payload.login_url
      state.isSucceeded = true
      return state
    },
    postGoogleLinkSuccess: (state) => {
      state.isSucceeded = true
    },
    requestFailure: (state) => {
      state.isSucceeded = false
      return state
    },
  },
})

export const {
  requestStart,
  postGoogleSyncSuccess,
  postGoogleLinkSuccess,
  requestFailure,
} = googleSyncSlice.actions

export const googleSyncReducer = googleSyncSlice.reducer

export const createGoogleSync = (
  callback: (google: GoogleSyncState) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postGoogleSync()
    .then((result) => {
      dispatch(postGoogleSyncSuccess(result))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}

export const createGoogleLink = (
  params: GoogleCallbackUrl,
  callback: (result: boolean) => void,
  errorCallback: () => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postGoogleLink(params)
    .then(() => {
      dispatch(postGoogleLinkSuccess())
      callback(true)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
      errorCallback()
    })
}

export const deleteGoogleSync = (
  callback: (google: GoogleSyncState) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  postGoogleDisassociation()
    .then((result) => {
      dispatch(postGoogleSyncSuccess(result))
      callback(result)
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
